<template lang="pug">
	div
		#sfc-main-container.sfc-container-redesign-v1
			sfc-sentry
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-hello-bar-v3
			sfc-enroll-now-urgency-widget(:inPage="false")
			sfc-menu
			sfc-menu-mobile
			sfc-onboarding-modal-v2
			sfc-header
			sfc-login
			sfc-forgot-password
			#sfc-main-content


				//- b-container.no-padding
				b-row.m-0.main-column
					b-col.content-container.m-0.p-0(cols="12" lg="8")
						nuxt
					b-col.d-none.d-lg-block.side.m-0.p-0(lg="4")
						.side-cont
							sfc-sidebar
				no-ssr(v-if="!userSubscribed()")
					b-row#bottom-ad
						.col-md-12.col-sm-12.col-xs-12.ad-align-center
							.bottom-banner(style="")
								sfc-dfp-ad(ad-unit="savingforcollege_other_bottom_leaderboard" sizes="[[600,230], [728,90]]")
			sfc-footer
			no-ssr
				sfc-gdpr-banner
		no-ssr
			sfc-college-savings-questions-modal
		no-ssr
			sfc-mobile-conversion-bar-ad
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	.padding-only-desktop
		border: 1px solid blue
	// .container-fluid
	// 	padding: 0
	// 	> .row
	// 		margin: 0
	// 		> .col
	// 			padding: 0
	// .padding-only-desktop
	// 	padding: 0 !important
	// 	.col-desktop-padding
	// 		@media (min-width: 768px)
	// 			padding: 0 15px !important
	// .side
	// 	border-left 1px solid sfc-pale-gray
	// 	overflow: hidden

	#sfc-main-content
		width: 1140px
		margin: auto
		@media(max-width: 1199px)
			width: 960px

		@media(max-width: 991px)
			width: 720px

		@media(max-width: 767px)
			width: 540px

		@media(max-width: 575px)
			width: 95%

		// .main-column
		// > .col


	#sfc-main-container
		background-color: sfc-layout-background
		& >>> #top-banner-desktop
			background-color: sfc-layout-background
			border: 0

		& >>> #top-banner-mobile
			background-color: sfc-layout-background
			border: 0

		.content-container
			background-color: #fff
			border: 1px solid sfc-pale-gray

		.side
			.side-cont
				height: 100%
				>>> .sidebar-container
					background-color: sfc-sidebar-background
					border: 1px solid sfc-pale-gray
					border-left: 0
					section.merril-banner
					section.sidebar-large
					section.text-ads
						float: none

					section.sponsor-center
						margin: 20px auto 0 auto
						float: none
						background: #fff
						padding: 15px 10px 0px
						border: 1px solid #ced3e1

					aside
						text-align: center

					#latest-articles
						h3
							padding: 25px

						.more-articles
							padding: 0 25px

						.section
							> span
								padding: 0 25px

					.main-table-container
						max-width: 100%
						padding: 0 25px
		#bottom-ad
			border: 0

</style>



<script>
import SfcHeader from '@/layouts/common/sfc-header-slim'
import SfcSidebar from '@/common/components/sfc-sidebar.vue'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'
import SfcHelloBarV3 from '@/common/components/hello-bar/sfc-hello-bar-v3'
import SfcEnrollNowUrgencyWidget from '@/common/components/redesign-v1/sfc-enroll-now-urgency-widget'
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'
import SfcMobileConversionBarAd from '@/common/components/sfc-mobile-conversion-bar-ad'

export default {
	components: {
		SfcHeader,
		SfcFooter,
		sfcCollegeSavingsQuestionsModal,
		SfcHelloBarV3,
		SfcEnrollNowUrgencyWidget,
		SfcSidebar,
		SfcMenu,
		SfcMenuMobile,
		SfcLogin,
		SfcForgotPassword,
		SfcOnboardingModalV2,
		SfcMobileConversionBarAd
	},
	computed: {
		containerClass: function (){
			let isSfcFinancialAidCalculator = this.$route.path.indexOf('/financial-aid-calculator') >= 0 && this.$route.path.indexOf('/financial-aid-calculator-portals') < 0
			return isSfcFinancialAidCalculator ? 'container' : 'container-fluid'
		}
	},
	methods: {
		userSubscribed(){
			return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
		}
	}
}
</script>
